// 通用表格（基于 antd/Table）— 数字列右对齐，紧凑模式
// 用 any 解开 antd 深层的泛型变型问题（render/title/sortColumn 互相递归）
import { Table } from 'antd'

interface Props {
  columns: any[]
  dataSource: any[]
  loading?: boolean
  pagination?: any
  onChange?: (pagination: any, filters: any, sorter: any, extra: any) => void
  size?: 'small' | 'middle' | 'large'
  rowKey?: string | ((record: any) => string)
  onRow?: (record: any, index?: number) => any
  className?: string
  scroll?: { x?: number | string; y?: number | string }
}

// 给数字类型列加默认右对齐，避免每个 column 重复写
function normalizeColumns(columns: any[]): any[] {
  return columns.map((c) => {
    if (c.align == null && (c.dataIndex || c.key) && /count|value|number|rate|percent|user|read|like|share|fav|hour|day|num/i.test(String(c.dataIndex ?? c.key ?? ''))) {
      c.align = 'right'
    }
    return c
  })
}

export default function DataTable({
  columns,
  dataSource,
  loading = false,
  pagination,
  onChange,
  size = 'small',
  rowKey = 'id',
  onRow,
  className,
  scroll,
}: Props) {
  return (
    <Table
      columns={normalizeColumns(columns)}
      dataSource={dataSource}
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      size={size}
      rowKey={rowKey as any}
      onRow={onRow}
      className={className}
      scroll={scroll}
    />
  )
}
